import React from 'react';
import { Link } from 'react-router-dom';

const INTERNAL_LINK_PATTERN = /\[([^\]]+)\]\((slug|page):([^)]+)\)/g;

export function renderArticleText(text: string): React.ReactNode[] {
  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;

  INTERNAL_LINK_PATTERN.lastIndex = 0;

  while ((match = INTERNAL_LINK_PATTERN.exec(text)) !== null) {
    const [fullMatch, anchor, kind, target] = match;
    const slug = target;
    const href = kind === 'page' ? target : `/blog/${slug}`;
    const offset = match.index;

    if (offset > lastIndex) {
      nodes.push(text.slice(lastIndex, offset));
    }

    nodes.push(
      <Link
        key={`${slug}-${offset}`}
        to={href}
        className="text-blue-400 hover:underline"
      >
        {anchor}
      </Link>,
    );

    lastIndex = offset + fullMatch.length;
  }

  if (lastIndex < text.length) {
    nodes.push(text.slice(lastIndex));
  }

  return nodes;
}
